import { useTheme } from '@mui/material/styles';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            backgroundColor: theme.palette.background,
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
            '& > *': {
                [theme.breakpoints.up('md')]: {
                    flexBasis: `calc(50% - ${theme.spacing(2)})`,
                },
                [theme.breakpoints.up('lg')]: {
                    flexBasis: `calc(33.33% - ${theme.spacing(2)})`,
                },
                [theme.breakpoints.down('md')]: {
                    flexBasis: `100%`,
                    flexGrow: 1,
                    marginRight: 0,
                    justifyContent: 'flex-start',
                },
            },
        },
        outerContainer: {
            display: 'flex',
            alignItems: 'flex-start',
        },
        container: {
            width: '70%',
            overflowX: 'auto',
            marginRight: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                marginRight: 0,
            },
        },
        grow: {
            borderRadius: theme.shape.borderRadius,
            flexGrow: 1,
            padding: `0 ${theme.spacing(2)} ${theme.spacing(2)}`,
            [theme.breakpoints.up('md')]: {
                marginTop: theme.spacing(6.25),
                border: `1px solid ${theme.palette.grey[300]}`,
            },
            [theme.breakpoints.down('sm')]: {
                paddingTop: theme.spacing(2),
            },
        },
        title: {
            color: theme.palette.primary.dark,
        },
        wrapperTitle: {
            color: theme.palette.primary.main,
        },
    };
};
